import { LocallyStoredFilterT } from '@/routes/projectStages/issues/lib/stores/useLocallyStoredFilters.ts'

export function findStoredTab(
  tabs: LocallyStoredFilterT[],
  userId: number | undefined,
  stageId: string | null,
): string | null {
  // console.log({tabs, userId, stageId})
  const storedTab = tabs.find(tab => tab.projectStageId == stageId && tab.userId == userId)
  if (storedTab?.pathname) {
    return storedTab.pathname
  } else {
    // console.log(`no stored tab found for stage ${stageId}`)
    return null
  }
}
